module.exports = __webpack_public_path__ + "static/media/vip-access-store-tile-3-promo.97d52812.png";